import { createFileRoute } from '@tanstack/react-router'
// eslint-disable-next-line import/no-unresolved
import Connect from '@ui/components/connect'
// eslint-disable-next-line import/no-unresolved
// eslint-disable-next-line import/no-unresolved
import Header from '@ui/components/header'
// eslint-disable-next-line import/no-unresolved
import Partners from '@ui/components/partners'

import SupplierTabs from '../components/tabs/supplier'

export const Route = createFileRoute('/supplier')({
  component: () => {
    return (
      <div className="w-full flex flex-col">
        <Header />
        <SupplierTabs />
        <Partners />
        <Connect />
      </div>
    )
  }
})
